import React from "react";
import jMoment from "components/classes/Jmomen";
import moment from "moment-jalaali";
import axios from "axios";
import config from "config/api";

// -------------------------------------------------------------------< constants >-------------------------------------------------------------------
const INDEX_ATTENDANCE_REPORT_RULES_SUCCESS =
  "INDEX_ATTENDANCE_REPORT_RULES_SUCCESS";
const INDEX_ATTENDANCE_REPORT_NEWREPORT_SUCCESS =
  "INDEX_ATTENDANCE_REPORT_NEWREPORT_SUCCESS";
const GET_ATTENDANCE_REPORT_NEWREPORT_SUCCESS =
  "GET_ATTENDANCE_REPORT_NEWREPORT_SUCCESS";
const INDEX_ATTENDANCE_REPORT_SUCCESS = "INDEX_ATTENDANCE_REPORT_SUCCESS";
const GET_ATTENDANCE_REPORT_RULES_SUCCESS =
  "GET_ATTENDANCE_REPORT_RULES_SUCCESS";
const INDEX_ATTENDANCE_REPORT_Custom_SUCCESS =
  "INDEX_ATTENDANCE_REPORT_Custom_SUCCESS";
// ----------------------------------------------------------------< action creators >----------------------------------------------------------------
/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _indexSuccess(payload) {
  return {
    type: INDEX_ATTENDANCE_REPORT_RULES_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _indexNewReportSuccess(payload) {
  return {
    type: INDEX_ATTENDANCE_REPORT_NEWREPORT_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _getNewReportSuccess(payload) {
  return {
    type: GET_ATTENDANCE_REPORT_NEWREPORT_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _showSuccess(payload) {
  return {
    type: GET_ATTENDANCE_REPORT_RULES_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _showReportSuccess(payload) {
  console.log("payloapayloadd", payload);

  return {
    type: INDEX_ATTENDANCE_REPORT_SUCCESS,
    payload: payload, // payload OR {data: tables}
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _showReportCustomSuccess(payload) {
  console.log("payloapayloadd", payload);

  return {
    type: INDEX_ATTENDANCE_REPORT_Custom_SUCCESS,
    payload: payload, // payload OR {data: tables}
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------
/**
 *
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Rule@getByCompanyCode")) {
      api
        .get("company/rules", { params })
        .then((res) => {
          dispatch(_indexSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.attendance.rules",
            "Rule",
            app.translate(".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید")
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Number} [id]
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function show(id, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    localStorage.setItem("reportId", id);
    // if (app.can("Rule@getByCompanyCode")) {
    api
      .get(`/rules/${id}`, { params })
      .then((res) => {
        //  console.log(res);
        dispatch(_showSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        app.error(
          err,
          "routes.home.attendance.rules",
          "Rule",
          app.translate(".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید")
        );
        callback(err);
      });
    // }
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------
/**
 *
 * @param {Number} [id={}]
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showReport(id, data = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Rule@getByCompanyCode")) {
      api
        .post(`ta/reports/${id}/run`, { data })
        .then((res) => {
          dispatch(_showReportSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.attendance.rules",
            "Rule",
            app.translate(".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید")
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showReportCustom(data = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Rule@getByCompanyCode")) {
      api
        .post(`ta/reports/GetCustomReport`, { data })
        .then((res) => {
          try {
            dispatch(_showReportCustomSuccess(res));

            // Call the callback with JSON data
            callback(undefined, res);
          } catch (error) {
            console.error("Error decoding base64 or parsing JSON:", error);
            callback(error);
          }
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.attendance.rules",
            "Rule",
            app.translate(".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید")
          );
          callback(err);
        });
    }
  };
}
/**
 *
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function downloadCustom(data = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Rule@getByCompanyCode")) {
      ZZZZZ;
      axios
        .get(`${config.url}/wwwroot${data}`)
        .then((res) => {
          try {
            dispatch(_showReportCustomSuccess(res));

            // Call the callback with JSON data
            callback(undefined, res.data);
          } catch (error) {
            console.error("Error decoding base64 or parsing JSON:", error);
            callback(error);
          }
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.attendance.rules",
            "Rule",
            app.translate(".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید")
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function saveReportFields(data = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .post(`users/form_fields`, { data })
      .then((res) => {
        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function createReport(data = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .post(`ta/report_builder`, { data })
      .then((res) => {
        // dispatch(_showReportSuccess(res));
        console.log("res", res);
        callback(undefined, res);
      })
      .catch((err) => {
        console.log("err", err);
        // app.error(
        //     err, 'routes.home.attendance.rules', 'Rule',
        //     app.translate('.خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید'),
        // );
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function renewedCalculate(data = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .post(`/ta/working_history/process`, { data })
      .then((res) => {
        callback(undefined, res);
      })
      .catch((err) => {
        app.error(
          err,
          "routes.home.attendance.reports",
          "Renewed calculate Faile",
          app.translate(
            "routes.home.attendance.reports.Renewed calculate Failed"
          )
        );
        callback(err);
      });
  };
}

/**
 * @param {Number} [id={}]
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function updateReport(id, data = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .put(`ta/report_builder/${id}`, { data })
      .then((res) => {
        // dispatch(_showReportSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        // app.error(
        //     err, 'routes.home.attendance.rules', 'Rule',
        //     app.translate('.خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید'),
        // );
        callback(err);
      });
  };
}

/**
 * @param {Number} [id={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function deleteReport(id, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .delete(`ta/report_builder/${id}`)
      .then((res) => {
        // dispatch(_showReportSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        // app.error(
        //     err, 'routes.home.attendance.rules', 'Rule',
        //     app.translate('.خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید'),
        // );
        callback(err);
      });
  };
}

/**
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function indexReports(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`ta/report_builder`, data)
      .then((res) => {
        dispatch(_indexNewReportSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        // app.error(
        //     err, 'routes.home.attendance.rules', 'Rule',
        //     app.translate('.خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید'),
        // );
        callback(err);
      });
  };
}

/**
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function getNewReport(newReportId, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`ta/report_builder/${newReportId}`)
      .then((res) => {
        dispatch(_getNewReportSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        // app.error(
        //     err, 'routes.home.attendance.rules', 'Rule',
        //     app.translate('.خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید'),
        // );
        callback(err);
      });
  };
}

/**
 * @param {Number} [id={}]
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function takeReport(id, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    api.get(`ta/report_builder/take_report/${id}`);
    api
      .get(`ta/report_builder/take_report/${id}`, { params: data })
      .then((res) => {
        dispatch(_showReportSuccess(res));

        // dispatch(_showReportSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        // app.error(
        //     err, 'routes.home.attendance.rules', 'Rule',
        //     app.translate('.خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید'),
        // );
        callback(err);
      });
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyRules() {
  return _indexSuccess({ data: { rules: [] }, meta: {} });
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyNewReports() {
  return _indexNewReportSuccess({ data: { reportType: [] }, meta: {} });
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyRule() {
  return _showSuccess({ data: { rule: {} } });
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyReport() {
  return _showReportSuccess({ data: {} });
}

/**
 *
 * @param {*} text
 * @param {Object} record
 * @param {String} key
 * @return {*}
 * @private
 */
function _renderCel(text, record, key) {
  //
  // let style = {};
  // if (record._props && record._props.background) {
  //   style = Object.assign({}, style, {background: record._props.background});
  // }

  let item = `${
    record._props && record._props[key] && record._props[key].before
      ? record._props[key].before
      : ""
  }
  ${text}
  ${
    record._props && record._props[key] && record._props[key].after
      ? record._props[key].after
      : ""
  }`;
  return {
    children: item,
    props: Object.assign({}, {}, record.props),
  };
}

/**
 *
 * @param {Array} dataTable
 * @return {Array}
 */
export function getColumns(dataTable) {
  let columns = [];
  let _column;
  let filter;
  let header = [];
  let openModal = "";

  if (!app._.isEmpty(dataTable)) {
    if (dataTable.header) {
      header = dataTable.header.payload;
      header.sort(function (_a, _b) {
        let a = parseInt(_a.priority ? _a.priority : 1);
        let b = parseInt(_b.priority ? _b.priority : 1);
        return a > b ? -1 : a < b ? 1 : 0;
      });
      app._.map(header, (column) => {
        filter = null;
        console.log("columncolumcolumnn", column);
        if (column.filter) {
          filter = [];
          column.filter.filterable.map((_filter) => {
            filter.push({ text: _filter, value: _filter });
          });
        }
        _column = {};
        _column = {
          key: app._.camelCase(column.key),
          title: app.translate(
            `routes.home.attendance.reports.${column.value}`,
            `${column.value}`
          ),
          // sorter: column.sortable ? column.sortable : false,
          width: column.props && column.props.width ? column.props.width : 145,
          valuesType: column.valuesType,
          children: column.children,
          colSpan: column.colSpan,
          props: column.props,
          // filters: filter,
        };

        if (
          column.valuesType === "string" ||
          (column.valuesType !== "date" && column.valuesType !== "datetime")
        ) {
          _column = Object.assign({}, _column, {
            render: (text, record) => {
              return _renderCel(
                text
                  ? app.translate(
                      `routes.home.attendance.reports.${text}`,
                      `${text}`
                    )
                  : "",
                record,
                column.key
              );
            },
          });
        } else {
          if (column.valuesType === "date") {
            _column = Object.assign({}, _column, {
              render: (text, record) => {
                return _renderCel(
                  text ? jMoment(text, "YYYY-M-D").format("jYYYY/jMM/jDD") : "",
                  record,
                  column.key
                );
              },
            });
          }
          if (column.valuesType === "datetime") {
            _column = Object.assign({}, _column, {
              render: (text, record) => {
                return _renderCel(
                  text
                    ? jMoment(text, "YYYY-M-D HH:mm:ss").format(
                        "HH:mm:ss jYYYY/jMM/jDD"
                      )
                    : "",
                  record,
                  column.key
                );
              },
            });
          }
        }

        // if()

        columns.push(_column);
      });
    }
  }
  return { columns, dataTable };
}

/**
 *
 * @param {Array} dataTable
 * @return {Array}
 */
export function getProperties(dataTable) {
  if (!app._.isEmpty(dataTable)) {
    return dataTable.props;
  }
  return {};
}

/**
 *
 * @param {Array} dataTable
 * @return {Array}
 */
export function getDataReport(dataTable) {
  console.log("payloadDapayloadDatata", dataTable);
  const CompanyCode = localStorage.getItem("CompanyCode");
  const reportId = localStorage.getItem("reportId");
  let data = [];
  let footerItems = [];
  let rows;
  let row = {};
  let i = 0;
  if (!app._.isEmpty(dataTable) && !app._.isEmpty(dataTable.payload)) {
    dataTable.payload.map((table) => {
      rows = [];
      console.log("tabltablee", table.body);

      table.body.map((_row) => {
        i++;
        row = _row.payload;
        row["props"] = [];
        row.key = i.toString();
        // row.valuesType = column.valuesType,
        row._props = _row.props;
        if (row._props && row._props.className && row._props.className !== "") {
          row.className = row._props.className;
        }
        const CompanyCode = localStorage.getItem("CompanyCode");
        //شهرداری ماکو
        if (CompanyCode == "15085") {
          // بررسی و جایگزینی مقادیر "00:00" 0"با
          Object.keys(row).forEach((key) => {
            if (row[key] === "00:00") {
              row[key] = "0";
            }
          });
        }
        //
        rows.push(row);
        row["className"] =
          reportId == 213 && _row.payload.presenceState === "غیبت"
            ? "record-IncompleteClocking"
            : reportId == 213 && _row.payload.presenceState === "تعطیل"
            ? "record-absence"
            : _row.payload.presenceState === "غیبت به علت تردد ناقص"
            ? "record-IncompleteClocking"
            : _row.payload.presenceState === "غیبت"
            ? "record-absence"
            : "";
      });
      table.footer.map((_row) => {
        i++;
        row = _row.payload;
        row["props"] = [];
        row.key = i.toString();
        row._props = Object.assign({}, _row.props, { type: "footer" });
        row.className = "reportTableFooter";
        rows.push(row);
        footerItems.push(row);
        console.log("_row_row_row", row);
      });

      data.push({ body: rows, props: table.props, footerItems: footerItems });
    });
  }
  console.log("234234233", data);

  return data;
}

export function getColumnsCustom(dataTable) {
  let columns = [];
  let _column;
  let filter;
  let header = [];
  let openModal = "";

  if (!app._.isEmpty(dataTable)) {
    console.log("dataTabldataTabsdfsdflee2", dataTable);

    if (dataTable.Header) {
      header = dataTable.Header.Payload;
      header.sort(function (_a, _b) {
        let a = parseInt(_a.Priority ? _a.Priority : 1);
        let b = parseInt(_b.Priority ? _b.Priority : 1);
        return a > b ? -1 : a < b ? 1 : 0;
      });
      app._.map(header, (column) => {
        filter = null;
        console.log("columncolumcolumnn", column);
        if (column.Filter) {
          filter = [];
          column.Filter.Filterable.map((_filter) => {
            filter.push({ text: _filter, value: _filter });
          });
        }
        _column = {};
        _column = {
          key: app._.camelCase(column.Key),
          title: app.translate(
            `routes.home.attendance.reports.${column.Value}`,
            `${column.Value}`
          ),
          // sorter: column.sortable ? column.sortable : false,
          width: column.Props && column.Props.Width ? column.Props.Width : 145,
          valuesType: column.ValuesType,
          children: column.Children,
          colSpan: column.ColSpan,
          props: column.Props,
          // filters: filter,
        };

        if (
          column.valuesType === "string" ||
          (column.valuesType !== "date" && column.valuesType !== "datetime")
        ) {
          _column = Object.assign({}, _column, {
            render: (text, record) => {
              return _renderCel(
                text
                  ? app.translate(
                      `routes.home.attendance.reports.${text}`,
                      `${text}`
                    )
                  : "",
                record,
                column.key
              );
            },
          });
        } else {
          if (column.valuesType === "date") {
            _column = Object.assign({}, _column, {
              render: (text, record) => {
                return _renderCel(
                  text ? jMoment(text, "YYYY-M-D").format("jYYYY/jMM/jDD") : "",
                  record,
                  column.key
                );
              },
            });
          }
          if (column.valuesType === "datetime") {
            _column = Object.assign({}, _column, {
              render: (text, record) => {
                return _renderCel(
                  text
                    ? jMoment(text, "YYYY-M-D HH:mm:ss").format(
                        "HH:mm:ss jYYYY/jMM/jDD"
                      )
                    : "",
                  record,
                  column.key
                );
              },
            });
          }
        }

        // if()
        console.log("columns.push(_column)", _column);

        columns.push(_column);
      });
    }
  }
  return { columns, dataTable };
}
/**
 *
 * @param {Array} dataTable
 * @return {Array}
 */
export function getDataReportCustom(dataTable) {
  let data = [];
  let footerItems = [];
  let rows;
  let row = {};
  let i = 0;

  if (!app._.isEmpty(dataTable) && !app._.isEmpty(dataTable.Payload)) {
    dataTable.Payload.map((table) => {
      rows = [];
      table.Body.map((_row) => {
        i++;
        row = { ..._row.Payload }; // کپی از `Payload`

        // تبدیل تاریخ میلادی به تاریخ جلالی
        // if (row.date) {
        //   row.date = "1400-02-32";
        // }

        row["props"] = [];
        row.key = i.toString();
        row._props = _row.Props;

        if (row._props && row._props.className && row._props.className !== "") {
          row.ClassName = row._props.className;
        }

        rows.push(row);
        row["className"] =
          _row.Payload.PresenceState === "غیبت به علت تردد ناقص"
            ? "record-IncompleteClocking"
            : _row.Payload.PresenceState === "غیبت"
            ? "record-absence"
            : "";
        console.log("Updated row with Jalali date:", row);
      });

      table.Footer.map((_row) => {
        console.log("Processing Footer row", dataTable.Payload);

        i++;
        row = { ..._row.Payload };
        row["props"] = [];
        row.key = i.toString();
        row._props = Object.assign({}, _row.Props, { type: "footer" });
        row.className = "reportTableFooter";
        rows.push(row);
        footerItems.push(row);

        console.log("Footer row with props:", row);
      });

      data.push({ Body: rows, props: table.props, footerItems: footerItems });
    });
  }

  console.log("Final data:", data);

  return data;
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(
  state = {
    rules: [],
    rule: {},
    dataReport: [],
    columns: [],
    properties: {},
    meta: {},
    newReports: [],
    metaNewReports: {},
    newReport: {},
    Footer: [],
    dataReportCustom: [],
  },
  action
) {
  let columns = [];
  let properties = [];
  let dataReport = [];
  let dataReportCustom = [];
  let Footer = [];
  let columnsCustom = [];
  switch (action.type) {
    case INDEX_ATTENDANCE_REPORT_RULES_SUCCESS:
      return Object.assign({}, state, {
        rules: action.payload.data.rules,
        meta: action.payload.meta,
      });
    case INDEX_ATTENDANCE_REPORT_NEWREPORT_SUCCESS:
      return Object.assign({}, state, {
        newReports: action.payload.data.reportType,
        metaNewReports: action.payload.meta,
      });
    case GET_ATTENDANCE_REPORT_NEWREPORT_SUCCESS:
      return Object.assign({}, state, {
        newReport: action.payload.data.reportType,
      });
    case GET_ATTENDANCE_REPORT_RULES_SUCCESS:
      return Object.assign({}, state, {
        rule: action.payload.rule,
      });
    case INDEX_ATTENDANCE_REPORT_SUCCESS:
      columns = getColumns(action.payload.data);
      properties = getProperties(action.payload.data);
      dataReport = getDataReport(action.payload.data);
      console.log("Decoded dataReportddd:", dataReport);
      console.log(
        "paloapapaloapayloadDatadDatayloadDatadData",
        action.payload.data
      );

      console.log("Decoded columns:", columns);

      return Object.assign({}, state, {
        dataReport,
        properties,
        columns,
        dataReportCustom,
        columnsCustom,
      });
    case INDEX_ATTENDANCE_REPORT_Custom_SUCCESS:
      function convertToCamelCase(obj) {
        if (Array.isArray(obj)) {
          return obj.map((item) => convertToCamelCase(item));
        } else if (obj !== null && typeof obj === "object") {
          return Object.keys(obj).reduce((acc, key) => {
            // تبدیل همه‌ی underscoreها و کاراکتر بعد از آن‌ها به حروف بزرگ
            const camelCaseKey = key.replace(/_([a-zA-Z0-9])/g, (_, letter) =>
              letter.toUpperCase()
            );
            acc[camelCaseKey] = convertToCamelCase(obj[key]);
            return acc;
          }, {});
        }
        return obj;
      }

      let payloadData = action.payload.data;
      console.log(
        "paloapapaloapayloadDatadDatayloadDatadData",
        action.payload.data
      );

      // Check if the data is in base64 format
      try {
        const binaryString = atob(payloadData);
        const utf8String = decodeURIComponent(
          binaryString
            .split("")
            .map(
              (char) => "%" + ("00" + char.charCodeAt(0).toString(16)).slice(-2)
            )
            .join("")
        );
        payloadData = JSON.parse(utf8String);
        payloadData = convertToCamelCase(payloadData);
      } catch (error) {
        console.error("Error decoding or parsing JSON from base64:", error);
      }

      properties = getProperties(payloadData);
      columnsCustom = getColumnsCustom(payloadData);
      dataReportCustom = getDataReportCustom(payloadData);

      return Object.assign({}, state, {
        properties,
        dataReportCustom,
        columnsCustom,
      });

    default:
      return state;
  }
}
